import React, {Component} from 'react';
import styled from "styled-components";

import {Switch, Route} from 'react-router-dom';

import _ from 'lodash';

import {SearchProfile} from '../../Shared';
import ContactApplicant from "../../Employers/Profiles/Contact";

import ProfileList from './ProfileList'
import Profile from './Profile'

const Container = styled.div`
  font-size: 1.0rem;
  min-height: 100vh;
`

export default class Profiles extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pending: true,
      keywords: props.keywords || '',
      location: props.location || ''
    }
  }

  render() {
    return (
      <Container id="profiles">
        <div style={{background: '#fff'}}>
          <SearchProfile history={this.props.history} {...this.state}/>
          <Switch>
            <Route exact path='/profiles' render={props => <ProfileList {...props} {...this.state}/> }/>
            <Route exact path='/profiles/:slug' render={(props) => (
              <ContactApplicant
                {...this.props}

                slug={props.match.params.slug}
              />
            )}/>
          </Switch>
        </div>
      </Container>
    )
  }
}
